import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';

import * as snackbarSelectors from '../../selectors/snackbarSelectors';
import * as snackbarConstants from '../../constants/snackbar';

import Snackbar from '@material-ui/core/Snackbar';

const DURATION = 3000;

const SnackbarWrapper = ({ snackbar, hideSnackbar, classes }) => {
    if (!snackbar) {
        return null;
    }

    const { type, message } = snackbar;
    return (
        <Snackbar
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            variant={type.variant}
            open={true}
            onClose={hideSnackbar}
            autoHideDuration={DURATION}
            message={
                <span className={classes.message}>
                    <i className={classes.icon}>{type.iconName}</i>
                    {message}
                </span>
            }
        />
    );
};

SnackbarWrapper.propTypes = {
    snackbar: PropTypes.object,
};

SnackbarWrapper.defaultProps = {
    snackbar: undefined,
};

const mapStateToProps = state => ({
    snackbar: snackbarSelectors.getSnackbar(state),
});

const mapDispatchToProps = dispatch => ({
    hideSnackbar: () =>
        dispatch({
            type: snackbarConstants.HIDE_SNACKBAR,
        }),
});

const style = ({ spacing }) => ({
    message: {
        display: 'flex',
        alignItems: 'center',
    },
    icon: {
        composes: ['material-icons'],
        marginRight: spacing.unit,
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(injectSheet(style)(SnackbarWrapper));



// WEBPACK FOOTER //
// ./src/containers/snackbar/Snackbar.js